//import { Tab } from "mdb-ui-kit";
import projectsData from "../assets/data/project.json";

const Project_bms_history = () => {
  /* const minSiYear = 2014;
  let maxSiYear = minSiYear;
  projectsData.si.forEach((element) => {
    if (maxSiYear < Number(element.year)) maxSiYear = element.year;
  });

  const siTimeline = [];
  for (let i = 0; maxSiYear >= minSiYear; maxSiYear--) {
    siTimeline[i++] = maxSiYear;
  } */

  const minSystemYear = 2014;
  let maxSystemYear = minSystemYear;
  projectsData.system.forEach((element) => {
    if (maxSystemYear < Number(element.year)) maxSystemYear = element.year;
  });

  const systemTimeline = [];
  for (let i = 0; maxSystemYear >= minSystemYear; maxSystemYear--) {
    systemTimeline[i++] = maxSystemYear;
  }

  return (
    <div id="project" className="">
      <div className="container-sm" style={{marginTop: "70px"}}>
        <div className="text-start mb-4">
          {/*<ul className="nav nav-tabs mb-3" id="ex1" role="tablist">
            <li className="nav-item" role="presentation">
              <a className="nav-link active" id="ex3-tab-1" data-mdb-toggle="tab" href="#ex3-tabs-1" role="tab" aria-controls="ex3-tabs-1" aria-selected="true">
                계측시스템
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a className="nav-link" id="ex3-tab-2" data-mdb-toggle="tab" href="#ex3-tabs-2" role="tab" aria-controls="ex3-tabs-2" aria-selected="false">
                SI프로젝트
              </a>
            </li>
          </ul>*/}

          <div className="tab-content" id="ex2-content">
            <div className="tab-pane show active" id="ex3-tabs-1" role="tabpanel" aria-labelledby="ex3-tab-1">
              <div className="timeline">
                {systemTimeline.map((year, idx) => (
                  <div key={idx} className={"project-container " + ((idx + 1) % 2 === 1 ? "project-left" : "project-right")}>
                    <div className="project-content">
                      <h3 className="project-year">{year}</h3>
                      <ul>
                        {projectsData.system.map((item, idx2) =>
                          item.year === year.toString() ? (
                            <li key={idx2}>
                              {item.name} / {item.site}
                            </li>
                          ) : null
                        )}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* <div className="tab-pane" id="ex3-tabs-2" role="tabpanel" aria-labelledby="ex3-tab-2">
              <div className="timeline">
                {siTimeline.map((year, idx) => (
                  <div key={idx} className={"project-container " + ((idx + 1) % 2 === 1 ? "project-left" : "project-right")}>
                    <div className="project-content">
                      <h3 className="project-year">{year}</h3>
                      <ul>
                        {projectsData.si.map((item, idx2) =>
                          item.year === year.toString() ? (
                            <li key={idx2}>
                              {item.name} / {item.site}
                            </li>
                          ) : null
                        )}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project_bms_history;
